import React, { useState } from "react";
import { Icon, Input, Button, Image, Grid } from "semantic-ui-react";
import { useNavigate, useLocation } from "react-router-dom";
import "../styles/AiNavbar.css";

const DashboardNavbar = ({
  setToggle,
  navTitle,
  type,
  handleFilterSort,
  handleChatHistoryOpen,
  ChatHistoryOpen,
  setChatHistoryOpen,
  activeTab, 
  setActiveTab,
  datasetId,
}) => {
  
  const navBarTitle = navTitle || "Default";
  const navigate = useNavigate();
  const location = useLocation();
  const hasQueryParams = location.search.length > 0;

  // Define the image mapping
  const imageMapping = {
    "Organization Dashboard": "/images/organisation-title.svg",
    "Dataset Dashboard": "/images/rating-title.svg",
    "Feedback Dashboard": "/images/feedback-title.svg",
    "User Engagement": "/images/dashboard.svg",
    "Default": "/images/dashboard.svg" // Default image
  };

  // Get the image source based on the navBarTitle
  const imageSrc = imageMapping[navBarTitle] || imageMapping["Default"];

  return (
    <Grid
      className="aiAssiatantRow"
      columns={2}
      divided={false}
      style={{ marginLeft: "18%" }}
      stackable
    >
      <Grid.Row className="aiAssiatantHeaderRow" style={{ background:"white" }}>
        <div className="aiAssistantSegment">
          {/* Mobile view */}
          <Grid.Column className="mobile-sidebar-icon">
            <Grid.Column>
              <div
                onClick={setToggle}
                className="button-mobile-sidebar-image mobileMenu"
              >
                <Image src="/images/mobile_menu.svg" alt="Menu Icon" />
              </div>
            </Grid.Column>
          </Grid.Column>
          {/* Mobile view end */}
          
          <Grid.Column className="aiAssiatantFirstDiv">
            <Grid.Column>
              <div className="menu-item-left-dashboard">
                <Image src={imageSrc} alt="Dashboard" />
                <label>{navBarTitle}</label>
              </div>
            </Grid.Column>
          </Grid.Column>
          {/* Mobile view */}
          <Grid.Column className="mobile-history-icon">
            <Grid.Column>
              {/* <div
                className="button-mobile-history-image chat-history-icon-mobile"
                onClick={handleChatHistoryOpen}
              >
                <Image
                  src="/images/chat-history.svg"
                  alt="Chat History"
                  data-cy="chat-history-img"
                />
              </div> */}
            </Grid.Column>
          </Grid.Column>
          {/* Mobile view end */}
          <Grid.Column className="aiAssiatantSecondDiv">
            <Grid.Column style={{ display: "flex", paddingTop: "29px" }}>
              {/* <Button
                primary
                className="button-ai-new-chat"
                onClick={() => handleView()}
                disabled={!hasQueryParams}
                data-cy="newchat-btn-click-cy"
              >
                <div className="button-ai-console-parent">
                  <Image
                    src="/images/white-chat-icons.svg"
                    alt="Add new Dataset"
                    data-cy="newchat-img-click-cy"
                  />
                  <label>New Chat</label>
                </div>
              </Button> */}
            </Grid.Column>
          </Grid.Column>
        </div>
        <Grid.Column
          className={
            ChatHistoryOpen
              ? "aiAssiatantHistoryHeaderMobile"
              : "aiAssiatantThirdDiv"
          }
        >
          <Grid.Column>
            {/* <div
              className={
                ChatHistoryOpen
                  ? "chatHistoryBoxMobile"
                  : "chatHistoryBox chatHistoryBoxDesktop"
              }
            > */}
              {/* <div
                className={
                  ChatHistoryOpen
                    ? "chatHistorySubBoxMobile"
                    : "chatHistorySubBoxDesktop"
                }
              > */}
                <div className="tab-container">
                  <div
                    className={`retrieval-tab tab ${activeTab === "retrievalParameter" ? "active" : ""} ${!datasetId ? "disabled" : ""}`}
                    onClick={() => {
                      if (datasetId) {
                        setActiveTab("retrievalParameter");
                      }
                    }}
                  >
                  </div>
                </div>
              {/* </div> */}
            {/* </div> */}
          </Grid.Column>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};

export default DashboardNavbar;